import { z } from 'zod';
import { FamilyId, FamilyPaymentMethodId } from '../types/branded';
import { FamilyPaymentMethodStatusSchema, FamilyPaymentMethodTypeSchema } from '../types/enums';

export const FamilyPaymentMethodSchema = z.object({
  id: FamilyPaymentMethodId,
  familyId: FamilyId,
  methodType: FamilyPaymentMethodTypeSchema,
  label: z.string().min(1),
  provider: z.string().nullable().optional(),
  lastFour: z.string().nullable().optional(),
  tokenRef: z.string().nullable().optional(),
  status: FamilyPaymentMethodStatusSchema.default('active'),
  preferred: z.boolean().default(false),
  metadata: z.record(z.string(), z.unknown()).optional(),
  createdAt: z.string(),
  updatedAt: z.string(),
});

export type FamilyPaymentMethod = z.infer<typeof FamilyPaymentMethodSchema>;
